import { c as _c } from "react/compiler-runtime";
import { Avatar, Stack, HStack, VStack, Text } from '@chakra-ui/react';
import { Icon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
interface WorkshopsCardProps {
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personTitle?: string;
  personAvatarUrl?: string;
  companyName?: string;
  quote: string;
  bgColor?: string;
  bgGradient?: string;
  color?: string;
}
const WorkshopsCard: React.FC<WorkshopsCardProps> = t0 => {
  const $ = _c(36);
  const {
    personFullName,
    personFirstName,
    personLastName,
    personTitle,
    personAvatarUrl,
    companyName,
    quote,
    bgColor,
    bgGradient,
    color
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue(["column", "column"]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color) {
    t2 = <HStack><Icon as={FaQuoteLeft} boxSize={8} color={color} /><Icon as={FaQuoteRight} boxSize={4} color={color} opacity={0.5} /></HStack>;
    $[2] = color;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== quote) {
    t3 = <Text color="textPrimary" fontSize="md" fontWeight={400} letterSpacing="normal" textStyle="labelLg">{quote}</Text>;
    $[4] = quote;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== getBreakpointValue) {
    t4 = getBreakpointValue(["md", "md"]);
    $[6] = getBreakpointValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Avatar.Fallback />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== personAvatarUrl) {
    t6 = <Avatar.Image src={personAvatarUrl} />;
    $[9] = personAvatarUrl;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <Avatar.Root boxShadow="base" size={t4}>{t5}{t6}</Avatar.Root>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== getBreakpointValue) {
    t8 = getBreakpointValue(["lg", "xl"]);
    $[14] = getBreakpointValue;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = personFullName ? personFullName : `${personFirstName} ${personLastName}`;
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <Text fontSize={t8} textStyle="labelLg">{t9}</Text>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = personTitle && companyName ? `${personTitle}, ${companyName}` : personTitle || companyName;
  let t12;
  if ($[19] !== t11) {
    t12 = <Text opacity={0.5} textStyle="badgeSm">{t11}</Text>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t12) {
    t13 = <VStack align="flex-start" gap={0}>{t10}{t12}</VStack>;
    $[21] = t10;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t7) {
    t14 = <HStack align="center" gap={4} width="full">{t7}{t13}</HStack>;
    $[24] = t13;
    $[25] = t7;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t2 || $[29] !== t3) {
    t15 = <VStack align="flex-start" gap={10} justify="space-between" padding={8}>{t2}{t3}{t14}</VStack>;
    $[27] = t14;
    $[28] = t2;
    $[29] = t3;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== bgColor || $[32] !== bgGradient || $[33] !== t1 || $[34] !== t15) {
    t16 = <Stack bg={bgGradient} bgColor={bgColor} borderRadius="2xl" boxShadow="sm" direction={t1} gap={0} justify="space-between" position="relative" width="full">{t15}</Stack>;
    $[31] = bgColor;
    $[32] = bgGradient;
    $[33] = t1;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};
export default WorkshopsCard;